import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const EmployeesListHeader = ({
  canAdd = false,
  companyId = '',
  subcompanyId = '',
  handleExport,
  t,
}) => {
  const handleExportCSV = (e) => {
    e.preventDefault();
    handleExport();
  };

  return <Common.Header title={t('employees.title')}></Common.Header>;
};

export default translate()(EmployeesListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/list/EmployeesListHeader.js